function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import SvgIcon from 'material-ui/SvgIcon';
export const StripeSvgIcon = ({
  svgColor = '#A3A3A3',
  wrapperClassName = '',
  style = {}
}) => /*#__PURE__*/React.createElement(SvgIcon, {
  className: wrapperClassName,
  style: _objectSpread({
    height: 'auto',
    width: 'auto'
  }, style),
  width: "50px",
  height: "21px",
  viewBox: "0 0 50 21"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0.0278611111 0.111138889 10.7223056 0.111138889 10.7223056 16.5277778 0.0278611111 16.5277778"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-3",
  points: "0 20.8055556 50 20.8055556 50 0 0 0"
})), /*#__PURE__*/React.createElement("g", {
  id: "Inventory",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "payment-method-8",
  transform: "translate(-580.000000, -832.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "payment-information",
  transform: "translate(560.000000, 200.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-13",
  transform: "translate(20.000000, 632.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M43.1388333,9.43056944 C43.1388333,7.861125 44.0971667,7.20834722 44.9721667,7.20834722 C45.8195278,7.20834722 46.7223056,7.861125 46.7223056,9.43056944 L43.1388333,9.43056944 Z M49.9999444,10.7500139 C49.9999444,7.19445833 48.2777222,4.38890278 44.9861944,4.38890278 C41.6805,4.38890278 39.6806389,7.19445833 39.6806389,10.7222361 C39.6806389,14.9027917 42.04175,17.0139028 45.4305,17.0139028 C47.0832778,17.0139028 48.3332778,16.6389028 49.2777222,16.111125 L49.2777222,13.3333472 C48.3332778,13.8055694 47.2500833,14.0972361 45.8749444,14.0972361 C44.5277222,14.0972361 43.3332778,13.6250139 43.1806389,11.986125 L49.9721667,11.986125 C49.9721667,11.8055694 49.9999444,11.0833472 49.9999444,10.7500139 L49.9999444,10.7500139 Z",
  id: "Fill-1",
  fill: svgColor
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-5",
  transform: "translate(28.333333, 4.277778)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.15272222,9.68058333 C4.33341667,9.68058333 3.84730556,9.38877778 3.51383333,9.02780556 L3.50008333,3.87502778 C3.86105556,3.47225 4.36119444,3.19447222 5.15272222,3.19447222 C6.41675,3.19447222 7.29161111,4.61113889 7.29161111,6.43058333 C7.29161111,8.29169444 6.4305,9.68058333 5.15272222,9.68058333 M5.98605556,0.111138889 C4.62494444,0.111138889 3.74994444,0.750027778 3.26383333,1.19447222 L3.08341667,0.333361111 L0.0278611111,0.333361111 L0.0278611111,16.5278056 L3.50008333,15.7916944 L3.51383333,11.8611389 C4.01397222,12.22225 4.75008333,12.7361389 5.97216667,12.7361389 C8.45841667,12.7361389 10.7223056,10.7361389 10.7223056,6.33322222 C10.7082778,2.30558333 8.41661111,0.111138889 5.98605556,0.111138889",
  id: "Fill-3",
  fill: svgColor,
  mask: "url(#mask-2)"
})), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-6",
  fill: svgColor,
  points: "27.0695 2.81944444 27.0695 0 23.58325 0.736111111 23.58325 3.56944444"
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-9"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-8",
  fill: svgColor,
  mask: "url(#mask-4)",
  points: "23.5833333 16.7777778 27.0695833 16.7777778 27.0695833 4.625 23.5833333 4.625"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.8472083,5.65276389 L19.6249861,4.62498611 L16.6249861,4.62498611 L16.6249861,16.7777639 L20.0972083,16.7777639 L20.0972083,8.54165278 C20.9166528,7.47220833 22.3055417,7.66665278 22.7360972,7.81943056 L22.7360972,4.62498611 C22.2916528,4.45831944 20.6666528,4.15276389 19.8472083,5.65276389",
  id: "Fill-10",
  fill: svgColor,
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.9027639,1.61108333 L9.513875,2.33330556 L9.49998611,13.4583056 C9.49998611,15.514 11.0416528,17.02775 13.0972083,17.02775 C14.2360972,17.02775 15.0694306,16.8194167 15.5277639,16.5694167 L15.5277639,13.7499722 C15.0833194,13.9305278 12.888875,14.5694167 12.888875,12.5138611 L12.888875,7.58330556 L15.5277639,7.58330556 L15.5277639,4.62497222 L12.888875,4.62497222 L12.9027639,1.61108333 Z",
  id: "Fill-11",
  fill: svgColor,
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.51386111,8.15276389 C3.51386111,7.61109722 3.95830556,7.40276389 4.69441667,7.40276389 C5.74997222,7.40276389 7.08330556,7.72220833 8.13886111,8.29165278 L8.13886111,5.02776389 C6.98608333,4.56943056 5.84719444,4.388875 4.69441667,4.388875 C1.87497222,4.388875 -2.77777778e-05,5.86109722 -2.77777778e-05,8.31943056 C-2.77777778e-05,12.1527639 5.27775,11.5416528 5.27775,13.1944306 C5.27775,13.8333194 4.72219444,14.0416528 3.94441667,14.0416528 C2.79163889,14.0416528 1.31941667,13.5694306 0.15275,12.9305417 L0.15275,16.2360972 C1.44441667,16.7916528 2.74997222,17.0277639 3.94441667,17.0277639 C6.83330556,17.0277639 8.81941667,15.5972083 8.81941667,13.1110972 C8.80552778,8.97220833 3.51386111,9.70831944 3.51386111,8.15276389",
  id: "Fill-12",
  fill: svgColor,
  mask: "url(#mask-4)"
}))))));